import { render, staticRenderFns } from "./expertDetails.vue?vue&type=template&id=5f012907"
import script from "./expertDetails.vue?vue&type=script&lang=js"
export * from "./expertDetails.vue?vue&type=script&lang=js"
import style0 from "./expertDetails.vue?vue&type=style&index=0&id=5f012907&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports